import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  token,
  locale,
  alert,
  float,
  required,
  params,
  tokens,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fax_contact: "",
      phone_contact: "",
      email_contact: "",
      name_contact_1: "",
      address_contact_1: "",
      phone_contact_1: "",
      fax_contact_1: "",
      email_contact_1: "",
      website_contact_1: "",
      name_contact_2: "",
      address_contact_2: "",
      phone_contact_2: "",
      fax_contact_2: "",
      email_contact_2: "",
      website_contact_2: "",

      full_name: "",
      email: "",
      phone: "",
      message: "",
    };
  }
  componentDidMount = async () => {
    loading(false);

    this.Get();
  };
  Get = async () => {
    loading(true);
    let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
      let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
      result = await response.json();
      localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    } else {
      result = tokens;
    }
    this.setState({
      fax_contact:
        result?.setting[`${locale}_fax_contact`] ||
        result?.setting?.th_fax_contact,
      phone_contact:
        result?.setting[`${locale}_phone_contact`] ||
        result?.setting?.th_phone_contact,
      email_contact:
        result?.setting[`${locale}_email_contact`] ||
        result?.setting?.th_email_contact,
      name_contact_1:
        result?.setting[`${locale}_name_contact_1`] ||
        result?.setting?.th_name_contact_1,
      address_contact_1:
        result?.setting[`${locale}_address_contact_1`] ||
        result?.setting?.th_address_contact_1,
      phone_contact_1:
        result?.setting[`${locale}_phone_contact_1`] ||
        result?.setting?.th_phone_contact_1,
      fax_contact_1:
        result?.setting[`${locale}_fax_contact_1`] ||
        result?.setting?.th_fax_contact_1,
      email_contact_1:
        result?.setting[`${locale}_email_contact_1`] ||
        result?.setting?.th_email_contact_1,
      website_contact_1:
        result?.setting[`${locale}_website_contact_1`] ||
        result?.setting?.th_website_contact_1,
      name_contact_2:
        result?.setting[`${locale}_name_contact_2`] ||
        result?.setting?.th_name_contact_2,
      address_contact_2:
        result?.setting[`${locale}_address_contact_2`] ||
        result?.setting?.th_address_contact_2,
      phone_contact_2:
        result?.setting[`${locale}_phone_contact_2`] ||
        result?.setting?.th_phone_contact_2,
      fax_contact_2:
        result?.setting[`${locale}_fax_contact_2`] ||
        result?.setting?.th_fax_contact_2,
      email_contact_2:
        result?.setting[`${locale}_email_contact_2`] ||
        result?.setting?.th_email_contact_2,
      website_contact_2:
        result?.setting[`${locale}_website_contact_2`] ||
        result?.setting?.th_website_contact_2,
    });
    loading(false);
  };
  Submit = async () => {
    const { product, full_name, email, phone, message } = this.state;
    if (!full_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาชื่อ-นามสกุล");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (phone.length < 10) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ครบถ้วน");
      return;
    }
    if (!float(phone)) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ถูกต้อง");
      return;
    }
    loading(true);

    await fetch(
      process.env.REACT_APP_API_URL + `/contact/${new Date().getTime()}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: new Date().getTime(),
          product,
          full_name,
          email,
          phone,
          message,
        }),
      }
    );
    loading(false);
    alert(
      "#",
      "success",
      "สำเร็จ",
      "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด"
    );
  };
  render() {
    const {
      fax_contact,
      phone_contact,
      email_contact,
      name_contact_1,
      address_contact_1,
      phone_contact_1,
      fax_contact_1,
      email_contact_1,
      website_contact_1,
      name_contact_2,
      address_contact_2,
      phone_contact_2,
      fax_contact_2,
      email_contact_2,
      website_contact_2,
      full_name,
      email,
      phone,
      message,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />
        {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../assets/images/bg-1.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 400,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">ติดต่อเรา</h1>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 bg-secondary-light">
          <div className="container mx-auto py-3 text-center">
            <div className="row">
              {fax_contact && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <span className="icon text-60 text-primary">
                      {"\uf1ac"}
                    </span>
                    <h5 className="fw-bold mb-3">โทรสาร</h5>
                    <span className="text-secondary">{fax_contact}</span>
                  </div>
                </div>
              )}
              {phone_contact && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <span className="icon text-60 text-primary">
                      {"\uf095"}
                    </span>
                    <h5 className="fw-bold mb-3">สำนักงานใหญ่</h5>
                    <span className="text-secondary">{phone_contact.split(",").map((phone, index) => <a href={`tel:${phone}`} key={index} style={{color: "inherit", textDecoration: "none"}}>{phone}{index !== phone_contact.split(",").length - 1 ? ", " : ""}</a>)}</span>
                  </div>
                </div>
              )}
              {email_contact && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <span className="icon text-60 text-primary">
                      {"\uf0e0"}
                    </span>
                    <h5 className="fw-bold mb-3">อีเมล</h5>
                    <span className="text-secondary"><a href={`mailto:${email_contact}`} style={{color: "inherit", textDecoration: "none"}}>{email_contact}</a></span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* SECTION 3 */}
        <div className="w-100 position-relative py-5">
          <div className="container">
            <div className="row mx-0 pb-5">
              <div className="col-12 col-lg-6 mb-3">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-12 mb-3 px-2">
                      <h3 className="fw-bold mb-3">{name_contact_1}</h3>
                      {address_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf015"}</h5>
                          </div>
                          <div>
                            <b>{name_contact_1}</b>
                            <br />
                            <span>{address_contact_1}</span>
                          </div>
                        </div>
                      )}
                      {phone_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf095"}</h5>
                          </div>
                          <div>
                            <b>โทรได้ที่</b>
                            <br />
                            <span>{phone_contact_1.split(",").map((phone, index) => <a href={`tel:${phone}`} key={index} style={{color: "inherit", textDecoration: "none"}}>{phone}{index !== phone_contact_1.split(",").length - 1 ? ", " : ""}</a>)}</span>
                          </div>
                        </div>
                      )}
                      {fax_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf1ac"}</h5>
                          </div>
                          <div>
                            <b>โทรสาร</b>
                            <br />
                            <span>{fax_contact_1}</span>
                          </div>
                        </div>
                      )}
                      {email_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf0e0"}</h5>
                          </div>
                          <div>
                            <b>อีเมล</b>
                            <br />
                            <span><a href={`mailto:${email_contact_1}`} style={{color: "inherit", textDecoration: "none"}}>{email_contact_1}</a></span>
                          </div>
                        </div>
                      )}
                      {website_contact_1 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf0ac"}</h5>
                          </div>
                          <div>
                            <b>เว็บไซต์</b>
                            <br />
                            <span><a href={website_contact_1} style={{color: "inherit", textDecoration: "none"}}>{website_contact_1}</a></span>
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="col-12 col-md-6 col-lg-12 mb-3 px-2">
                      <h3 className="fw-bold mb-3">{name_contact_2}</h3>
                      {address_contact_2 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf015"}</h5>
                          </div>
                          <div>
                            <b>{name_contact_2}</b>
                            <br />
                            <span>{address_contact_2}</span>
                          </div>
                        </div>
                      )}
                      {phone_contact_2 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf095"}</h5>
                          </div>
                          <div>
                            <b>โทรได้ที่</b>
                            <br />
                            <span>{phone_contact_2.split(",").map((phone, index) => <a href={`tel:${phone}`} key={index} style={{color: "inherit", textDecoration: "none"}}>{phone}{index !== phone_contact_2.split(",").length - 1 ? ", " : ""}</a>)}</span>
                          </div>
                        </div>
                      )}
                      {fax_contact_2 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf1ac"}</h5>
                          </div>
                          <div>
                            <b>โทรสาร</b>
                            <br />
                            <span>{fax_contact_2}</span>
                          </div>
                        </div>
                      )}
                      {email_contact_2 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf0e0"}</h5>
                          </div>
                          <div>
                            <b>อีเมล</b>
                            <br />
                            <span><a href={`mailto:${email_contact_2}`} style={{color: "inherit", textDecoration: "none"}}>{email_contact_2}</a></span>
                           </div>
                        </div>
                      )}
                      {website_contact_2 && (
                        <div className="d-flex align-items-center mb-3">
                          <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                            <h5 className="icon fw-bold text-22">{"\uf0ac"}</h5>
                          </div>
                          <div>
                            <b>เว็บไซต์</b>
                            <br />
                            <span><a href={website_contact_2} style={{color: "inherit", textDecoration: "none"}}>{website_contact_2}</a></span>
                          </div>
                        </div>
                      )}
                    </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 py-5" id="input-message">
                <div className="card card-dashboard rounded-3 bg-secondary-light p-4 shadow-sm border-0">
                  {/* <div className="d-flex justify-content-center align-items-center mb-4">
                           <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
                           <h6 className="text-danger mb-0 mx-3">ติดต่อเรา</h6>
                           <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
                         </div> */}
                  <div className="row">
                    <div className="col-12">
                      <div className="mb-2">ชื่อ - นามสกุล</div>
                      <input
                        className="form-control mb-3"
                        type="text"
                        placeholder="ชื่อ - นามสกุล"
                        onChange={(e) => {
                          this.setState({ full_name: e.target.value });
                        }}
                        value={full_name}
                      />
                    </div>
                    <div className="col-12">
                      <div className="mb-2">อีเมล</div>
                      <input
                        className="form-control mb-3"
                        type="email"
                        placeholder="อีเมล"
                        onChange={(e) => {
                          this.setState({ email: e.target.value });
                        }}
                        value={email}
                      />
                    </div>
                    <div className="col-12">
                      <div className="mb-2">เบอร์โทรศัพท์</div>
                      <input
                        className="form-control mb-3"
                        type="text"
                        placeholder="เบอร์โทรศัพท์"
                        maxLength={10}
                        onChange={(e) => {
                          if (!float(e.target.value)) {
                            return;
                          }
                          this.setState({ phone: e.target.value });
                        }}
                        value={phone}
                      />
                    </div>
                    <div className="col-12">
                      <div className="mb-2">ข้อความที่ต้องการติดต่อ</div>
                      <textarea
                        className="form-control mb-3"
                        rows={8}
                        placeholder="ข้อความที่ต้องการติดต่อ"
                        onChange={(e) => {
                          this.setState({ message: e.target.value });
                        }}
                        value={message}
                      />
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary px-5 w-100"
                        onClick={async () => {
                          this.Submit();
                        }}
                      >
                        ส่งข้อความ
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
